export const OPEN_DIALOG_TREND_PARK = "OPEN_DIALOG_TREND_PARK";
export const CLOSE_DIALOG_TREND_PARK = "CLOSE_DIALOG_TREND_PARK";
export const GET_PARK_TREND_SIGNALS = "GET_PARK_TREND_SIGNALS";
export const GET_PARK_TREND_SIGNALS_SUCCESS = "GET_PARK_TREND_SIGNALS_SUCCESS";
export const GET_PARK_TREND_SIGNALS_ERROR = "GET_PARK_TREND_SIGNALS_ERROR";
export const GET_PARK_TREND_SIGNALS_RECORDS = "GET_PARK_TREND_SIGNALS_RECORDS";
export const GET_PARK_TREND_SIGNALS_RECORDS_SUCCESS = "GET_PARK_TREND_SIGNALS_RECORDS_SUCCESS";
export const GET_PARK_TREND_SIGNALS_RECORDS_ERROR = "GET_PARK_TREND_SIGNALS_RECORDS_ERROR";
export const GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED = "GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED";
export const GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_SUCCESS = "GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_SUCCESS";
export const GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_ERROR = "GET_PARK_TREND_SIGNALS_RECORDS_STRATIFIED_ERROR";
export const TREND_PARK_CHART_ERROR_HANDLER = "TREND_PARK_CHART_ERROR_HANDLER";
export const CLOSE_SNACK_BAR = "CLOSE_SNACK_BAR";
export const TRIGGER_SNACK_BAR = "TRIGGER_SNACK_BAR";
